import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { monoChipStyle, monoChipWarningStyle, valueStyle } from './vinExtractionStyles';

const StatusModelChip = ({ model, modelAllowed }) => {
    const { t } = useTranslation('vinExtraction');

    if (!model) return <span style={valueStyle}>{t('status.noModel')}</span>;
    if (modelAllowed) return <code style={monoChipStyle}>{model}</code>;

    return (
        <Tooltip title={t('status.modelNotAllowed')}>
            <code style={monoChipWarningStyle} tabIndex={0} aria-label={`${model}: ${t('status.modelNotAllowed')}`}>
                {model} <i className="fi fi-rr-triangle-warning" aria-hidden="true" />
            </code>
        </Tooltip>
    );
};

export default StatusModelChip;
